import { useEffect } from 'react';
import { useAuthBootstrap } from './auth/bootstrap';
import { useBootstrapGate } from './bootstrap/useBootstrapGate';
import { AppRouter } from './router';
import { installDefaultCsrfProvider } from './runtime/http';
import { useSessionStore } from './store/sessionStore';

export function OSShell() {
  useEffect(() => {
    installDefaultCsrfProvider(
      () => useSessionStore.getState().csrfToken,
    );
  }, []);

  useAuthBootstrap();
  useBootstrapGate();
  return <AppRouter />;
}
